import './BetbookCommentEditor.less';
import React, { useEffect, useMemo, useState } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import { ticketsFromMessage, stripTickets } from '@/forum/commentTicket';
import { analysesFromMessage, stripAnalyses } from '@/forum/commentAnalyse';
import InfoIcon from '@/icons/InfoIcon';
import i18n from '@i18n';
import BetbookCommentHeader from '@/betbook/components/betbook-comment-header/BetbookCommentHeader';
import PopupNg from '@/ui/PopupNg';
import imports from '@/routing/imports';
import { pickModule } from '@/common/lazy/Loadable';
import { createComment, updateComment } from '@/betbook/handlers';
import { forumTopicReset, setTopicAnalyses, setTopicTickets } from '@/forum/ticketpicker/handlersAndSubs';
import { accountUserData$ } from '@/account/subs';
import { commentedCommentId$ } from '@/betbook/subs';

const ChatInput = React.lazy(() => imports.chat().then(pickModule('ChatInput')));

function BetbookCommentEditor({ subjectId, subjectType, parentCommentId = null, initialText = '', commentId }) {
    const { subscribe } = useReframe();
    const { avatar: avatarId, nickname, idZak: loggedIn } = subscribe(accountUserData$);
    const topic = parentCommentId || commentId ? 'betboook-' + parentCommentId + '-' + commentId : 'topic-items';

    const strippedText = useMemo(() => stripAnalyses(stripTickets(initialText)), [initialText]);

    const userNickname = loggedIn ? nickname : i18n('jsp.login.Prihlasit');
    const [openPicker, setOpenPicker] = useState(false);

    const commentedCommentId = subscribe(commentedCommentId$);

    useEffect(() => {
        const analyses = Object.values(analysesFromMessage(initialText));
        const tickets = Object.values(ticketsFromMessage(initialText, true));
        analyses.length && dispatch(setTopicAnalyses(topic, analyses));
        tickets.length && dispatch(setTopicTickets(topic, tickets));
        return () => dispatch(forumTopicReset(topic));
    }, [topic, commentedCommentId, initialText]);

    if (parentCommentId && commentedCommentId !== parentCommentId) {
        return null;
    }

    function onSend(text) {
        if (commentId) {
            dispatch(updateComment(commentId, text));
        } else {
            const data = { avatarId, device: 'MOBILE', parentCommentId, text };
            dispatch(createComment(data, subjectType, subjectId, nickname, avatarId));
        }
    }

    function loginAction() {
        dispatch(['login.openScreen']);
    }

    function openTicketPicker(opened) {
        setOpenPicker(opened);
        opened && PopupNg.dispatcher.open('ticketEditor/popup', { topic, onClose: () => setOpenPicker(false) });
    }

    return (
        <div className="betbook-comment-editor" onClick={loggedIn ? null : loginAction}>
            {commentId ? null : <BetbookCommentHeader className="own" avatarId={avatarId} nickname={userNickname} />}
            {loggedIn ? (
                <React.Suspense fallback={null}>
                    <ChatInput
                        initialText={strippedText}
                        onSend={onSend}
                        setOpenPicker={openTicketPicker}
                        openPicker={openPicker}
                        topic={topic}
                    />
                </React.Suspense>
            ) : (
                <div className="not-logged-input">
                    <div className="info-icon">
                        <InfoIcon width={20} height={20} fill={'#656d78'} opacity={0.8} />
                    </div>
                    {i18n('betbook.comments.loginForComment')}
                </div>
            )}
        </div>
    );
}
export default BetbookCommentEditor;
